import React from 'react'

function Settings() {
  return (
    <div className="flex justify-center items-center mt-48">
       Coming soon
    </div>
  )
}

export default Settings
